
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskTemplateModel } from './Entities.GormCrm.TaskTemplate';
import { TaskflowTemplateTagModel } from './Entities.GormCrm.TaskflowTemplateTag';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { Model, ModelProperty } from 'models/Model';


export class TaskflowTemplateModel extends Model<TaskflowTemplateModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'title', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'taskTemplates', type: 'TaskTemplateModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskTemplateModel }, properties: () => { return TaskTemplateModel.classProperties } },
		{ name: 'taskflowTemplateTags', type: 'TaskflowTemplateTagModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskflowTemplateTagModel }, properties: () => { return TaskflowTemplateTagModel.classProperties } },
		{ name: 'taskflows', type: 'TaskflowModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public title: string;
	public created?: Date;
	public deleted?: Date;
	public taskTemplates: TaskTemplateModel[];
	public taskflowTemplateTags: TaskflowTemplateTagModel[];
	public taskflows: TaskflowModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.title = '';
		this.created = undefined;
		this.deleted = undefined;
		this.taskTemplates = [];
		this.taskflowTemplateTags = [];
		this.taskflows = [];
		
	}
	getProperties(){
		return TaskflowTemplateModel.classProperties;
	}
}

